import { c as _c } from "react/compiler-runtime";
import React from 'react';
const sizerStyle: React.CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  visibility: 'hidden',
  height: 0,
  overflow: 'scroll',
  whiteSpace: 'pre'
};
const copyStyles = (styles, node) => {
  node.style.fontSize = styles.fontSize;
  node.style.fontFamily = styles.fontFamily;
  node.style.fontWeight = styles.fontWeight;
  node.style.fontStyle = styles.fontStyle;
  node.style.letterSpacing = styles.letterSpacing;
  node.style.textTransform = styles.textTransform;
};
const isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
const generateId = () => {
  // we only need an auto-generated ID for stylesheet injection, which is only
  // used for IE. so if the browser is not IE, this should return undefined.
  return isIE ? '_' + Math.random().toString(36).substring(2, 14) : undefined;
};
interface AutosizeInputProps {
  defaultValue?: any; // default field value
  extraWidth?: number | string; // additional width for input element
  injectStyles?: boolean; // inject the custom stylesheet to hide clear UI, defaults to true
  inputClassName?: string; // className for the input element
  inputStyle?: React.CSSProperties; // css styles for the input element
  minWidth?: number | string; // minimum width for input element
  onAutosize?: (newWidth: number | string) => void; // onAutosize handler: function(newWidth) {}
  placeholderIsMinWidth?: boolean; // don't collapse size to less than the placeholder
  value: any; // field value
}
function AutosizeInput(t0) {
  const $ = _c(80);
  let className;
  let defaultValue;
  let extraWidthProp;
  let id;
  let inputClassName;
  let inputStyleProp;
  let onAutosize;
  let onChange;
  let placeholder;
  let placeholderIsMinWidth;
  let ref;
  let rest;
  let style;
  let t1;
  let t2;
  let type;
  let value;
  if ($[0] !== t0) {
    ({
      ref,
      type,
      className,
      defaultValue,
      extraWidth: extraWidthProp,
      id,
      injectStyles: t1,
      inputClassName,
      inputStyle: inputStyleProp,
      minWidth: t2,
      onAutosize,
      onChange,
      placeholder,
      placeholderIsMinWidth,
      style,
      value,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = defaultValue;
    $[3] = extraWidthProp;
    $[4] = id;
    $[5] = inputClassName;
    $[6] = inputStyleProp;
    $[7] = onAutosize;
    $[8] = onChange;
    $[9] = placeholder;
    $[10] = placeholderIsMinWidth;
    $[11] = ref;
    $[12] = rest;
    $[13] = style;
    $[14] = t1;
    $[15] = t2;
    $[16] = type;
    $[17] = value;
  } else {
    className = $[1];
    defaultValue = $[2];
    extraWidthProp = $[3];
    id = $[4];
    inputClassName = $[5];
    inputStyleProp = $[6];
    onAutosize = $[7];
    onChange = $[8];
    placeholder = $[9];
    placeholderIsMinWidth = $[10];
    ref = $[11];
    rest = $[12];
    style = $[13];
    t1 = $[14];
    t2 = $[15];
    type = $[16];
    value = $[17];
  }
  const injectStyles = t1 === undefined ? true : t1;
  const minWidth = t2 === undefined ? 1 : t2;
  const [inputWidth, setInputWidth] = React.useState(minWidth);
  let t3;
  if ($[18] !== id) {
    t3 = id || generateId();
    $[18] = id;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  const [inputId, setInputId] = React.useState(t3);
  const mounted = React.useRef(false);
  const inputRef = React.useRef(null);
  const placeHolderSizerRef = React.useRef(null);
  const sizerRef = React.useRef(null);
  let t4;
  if ($[20] !== ref) {
    t4 = v => {
      if (typeof ref === "function") {
        ref(v);
      } else {
        ref.current = v;
      }
      inputRef.current = v;
    };
    $[20] = ref;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  const setInputRef = t4;
  let t5;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      if (!mounted.current || !window.getComputedStyle) {
        return;
      }
      const inputStyles = inputRef.current && window.getComputedStyle(inputRef.current);
      if (!inputStyles) {
        return;
      }
      copyStyles(inputStyles, sizerRef.current);
      if (placeHolderSizerRef.current) {
        copyStyles(inputStyles, placeHolderSizerRef.current);
      }
    };
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  const copyInputStyles = t5;
  let t6;
  if ($[23] !== extraWidthProp || $[24] !== inputWidth || $[25] !== minWidth || $[26] !== placeholder || $[27] !== placeholderIsMinWidth || $[28] !== type || $[29] !== value) {
    t6 = () => {
      if (!mounted.current || !sizerRef.current || typeof sizerRef.current.scrollWidth === "undefined") {
        return;
      }
      let newInputWidth;
      if (placeholder && (!value || value && placeholderIsMinWidth)) {
        newInputWidth = Math.max(sizerRef.current.scrollWidth, placeHolderSizerRef.current.scrollWidth) + 2;
      } else {
        newInputWidth = sizerRef.current.scrollWidth + 2;
      }
      const extraWidth = type === "number" && extraWidthProp === undefined ? 16 : parseInt(String(extraWidthProp)) || 0;
      newInputWidth = newInputWidth + extraWidth;
      if (newInputWidth < minWidth) {
        newInputWidth = minWidth;
      }
      if (newInputWidth !== inputWidth) {
        setInputWidth(newInputWidth);
      }
    };
    $[23] = extraWidthProp;
    $[24] = inputWidth;
    $[25] = minWidth;
    $[26] = placeholder;
    $[27] = placeholderIsMinWidth;
    $[28] = type;
    $[29] = value;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  const updateInputWidth = t6;
  let t7;
  let t8;
  if ($[31] !== updateInputWidth) {
    t7 = () => {
      mounted.current = true;
      copyInputStyles();
      updateInputWidth();
      return () => {
        mounted.current = false;
      };
    };
    t8 = [copyInputStyles, updateInputWidth];
    $[31] = updateInputWidth;
    $[32] = t7;
    $[33] = t8;
  } else {
    t7 = $[32];
    t8 = $[33];
  }
  React.useLayoutEffect(t7, t8);
  let t10;
  let t9;
  if ($[34] !== id) {
    t9 = () => {
      setInputId(id || generateId());
    };
    t10 = [id];
    $[34] = id;
    $[35] = t10;
    $[36] = t9;
  } else {
    t10 = $[35];
    t9 = $[36];
  }
  React.useLayoutEffect(t9, t10);
  let t11;
  let t12;
  if ($[37] !== inputWidth || $[38] !== onAutosize) {
    t11 = () => {
      if (typeof onAutosize === "function") {
        onAutosize(inputWidth);
      }
    };
    t12 = [inputWidth, onAutosize];
    $[37] = inputWidth;
    $[38] = onAutosize;
    $[39] = t11;
    $[40] = t12;
  } else {
    t11 = $[39];
    t12 = $[40];
  }
  React.useLayoutEffect(t11, t12);
  let t13;
  if ($[41] !== updateInputWidth) {
    t13 = () => {
      updateInputWidth();
    };
    $[41] = updateInputWidth;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  React.useLayoutEffect(t13);
  let t14;
  if ($[43] !== injectStyles || $[44] !== inputId) {
    t14 = () => isIE && injectStyles ? <style dangerouslySetInnerHTML={{
      __html: `input#${inputId}::-ms-clear {display: none;}`
    }} /> : null;
    $[43] = injectStyles;
    $[44] = inputId;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  const renderStyles = t14;
  let t15;
  if ($[46] !== defaultValue || $[47] !== value) {
    t15 = [defaultValue, value, ""].reduce(_temp);
    $[46] = defaultValue;
    $[47] = value;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  const sizerValue = t15;
  let wrapperStyle;
  if ($[49] !== style) {
    wrapperStyle = {
      ...style
    };
    if (!wrapperStyle.display) {
      wrapperStyle.display = "inline-block";
    }
    $[49] = style;
    $[50] = wrapperStyle;
  } else {
    wrapperStyle = $[50];
  }
  const t16 = `${inputWidth}px`;
  let t17;
  if ($[51] !== inputStyleProp || $[52] !== t16) {
    t17 = {
      boxSizing: "content-box",
      width: t16,
      ...inputStyleProp
    };
    $[51] = inputStyleProp;
    $[52] = t16;
    $[53] = t17;
  } else {
    t17 = $[53];
  }
  const inputStyle = t17;
  let t18;
  if ($[54] !== defaultValue || $[55] !== inputClassName || $[56] !== inputId || $[57] !== inputStyle || $[58] !== onChange || $[59] !== placeholder || $[60] !== rest || $[61] !== type || $[62] !== value) {
    t18 = {
      type,
      className: inputClassName,
      defaultValue,
      id: inputId,
      onChange,
      placeholder,
      style: inputStyle,
      value,
      ...rest
    };
    $[54] = defaultValue;
    $[55] = inputClassName;
    $[56] = inputId;
    $[57] = inputStyle;
    $[58] = onChange;
    $[59] = placeholder;
    $[60] = rest;
    $[61] = type;
    $[62] = value;
    $[63] = t18;
  } else {
    t18 = $[63];
  }
  const inputProps = t18;
  let t19;
  if ($[64] !== renderStyles) {
    t19 = renderStyles();
    $[64] = renderStyles;
    $[65] = t19;
  } else {
    t19 = $[65];
  }
  let t20;
  if ($[66] !== inputProps || $[67] !== setInputRef) {
    t20 = <input type="text" {...inputProps} ref={setInputRef} />;
    $[66] = inputProps;
    $[67] = setInputRef;
    $[68] = t20;
  } else {
    t20 = $[68];
  }
  let t21;
  if ($[69] !== sizerValue) {
    t21 = <div ref={sizerRef} style={sizerStyle}>{sizerValue}</div>;
    $[69] = sizerValue;
    $[70] = t21;
  } else {
    t21 = $[70];
  }
  let t22;
  if ($[71] !== placeholder) {
    t22 = placeholder ? <div ref={placeHolderSizerRef} style={sizerStyle}>{placeholder}</div> : null;
    $[71] = placeholder;
    $[72] = t22;
  } else {
    t22 = $[72];
  }
  let t23;
  if ($[73] !== className || $[74] !== t19 || $[75] !== t20 || $[76] !== t21 || $[77] !== t22 || $[78] !== wrapperStyle) {
    t23 = <div className={className} style={wrapperStyle}>{t19}{t20}{t21}{t22}</div>;
    $[73] = className;
    $[74] = t19;
    $[75] = t20;
    $[76] = t21;
    $[77] = t22;
    $[78] = wrapperStyle;
    $[79] = t23;
  } else {
    t23 = $[79];
  }
  return t23;
}
function _temp(previousValue, currentValue) {
  if (previousValue !== null && previousValue !== undefined) {
    return previousValue;
  }
  return currentValue;
}
export default AutosizeInput;